export const getPath = (pages, linkName) =>
  pages.filter((page) => page.linkName).find((page) => page.linkName === linkName).path;
